import { render, staticRenderFns } from "./iconSinglePayment.vue?vue&type=template&id=79a51a89&scoped=true"
import script from "./iconSinglePayment.vue?vue&type=script&lang=js"
export * from "./iconSinglePayment.vue?vue&type=script&lang=js"
import style0 from "./iconSinglePayment.vue?vue&type=style&index=0&id=79a51a89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a51a89",
  null
  
)

export default component.exports